import { shallowEqual, useSelector } from "react-redux";
import {
  selectActiveReportingPeriodPaths,
  selectRenderPaths,
} from "../../services/submissionPeriod/slices";
import CreateLinks from "./CreateLinks";


const OpenFormsLinks = (props = {}) => {
  const isOpen = useSelector(selectRenderPaths);
  const paths = useSelector(selectActiveReportingPeriodPaths, shallowEqual);

  if (!isOpen || !paths.length) {
    return false;
  }
  return <CreateLinks 
    paths={paths}
    {...props}
  />
};

export default OpenFormsLinks;
